/* eslint semi:0 */
import m from 'mithril'
import AnalyticsBaseService from '../../services/analytics/analyticsBaseService'
import pageDataObject from '../../../application/pageDataObject'
import utilsWindow from '../../../utils/window'
import { makeImage } from '../../../utils/dom'
import { getPlatform } from '../../../utils/ua'
import userStore from '../../stores/userStore'
import { i18n } from '../../../providers/i18nProvider/i18nProvider'
import { getCurrentCountryCode } from '../../../providers/geolocationProvider'
import networkProvider from '../../../providers/networkProvider'

const URL = 'http://go.ftbpro.com/visit/'

export class AffiliatesService extends AnalyticsBaseService {
  get className() {
    return 'AffiliatesService'
  }

  pageViewed() {
    if (this.shouldReportPageview) {
      this.trackEventOld({
        r: 0,
        bta: this.affiliateId,
      })
      this.trackEvent({
        /* eslint-disable camelcase */
        uid: userStore.guestId,
        affiliate_id: this.affiliateId,
        device_type: getPlatform(),
        locale: i18n.locale,
        country: getCurrentCountryCode(),
        /* eslint-enable */
      })
      // userStore.resetSessionStartTime()
    }
  }

  routeChanged(action) {
    //Empty override to prevent a read report on slideshows on each slide change
  }

  get shouldReportPageview() {
    return !!(
      this.affiliateId &&
      (pageDataObject.get('page.type') || '').match(/post/i) &&
      userStore.isNewSession
    )
  }

  get affiliateId() {
    return utilsWindow.queryString.a_aid
  }

  trackEventOld(data) {
    //Old system, is going to be deprecated
    this.logAnalytics(data)
    let serializedParams = m.route.buildQueryString(data)
    makeImage({
      src: `${URL}?${serializedParams}`,
    })
  }

  trackEvent(data) {
    this.logAnalytics(data)
    let serializedParams = m.route.buildQueryString(data)
    networkProvider.safeRequest({
      method: 'GET',
      url: `${pageDataObject.get(
        'config.affiliates_bq.proxy'
      )}/affiliates_traffic_stats?${serializedParams}`,
    })
  }
}

export default AffiliatesService



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/analytics/affiliatesService.js